module.exports = __webpack_public_path__ + "static/media/OnlyFans.3cd2c75d.png";